import React from 'react';

const MentionsLegalesPage = () => {
  return (
    <div data-testid="mentions-legales-page">
      <section className="pt-32 pb-20 bg-[#0e1c3f]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <p className="text-[#0078b7] font-bold tracking-[0.2em] uppercase text-sm mb-4">Informations juridiques</p>
            <h1 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl text-white uppercase tracking-tight">
              Mentions Légales
            </h1>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">

          <h2 className="font-display font-bold text-2xl text-[#0e1c3f] uppercase mt-10 mb-4">1. Éditeur du site</h2>
          <div className="bg-slate-50 border border-slate-200 p-6 mb-8">
            <p className="text-slate-700 leading-relaxed mb-1"><strong>SOPREL GROUPE</strong></p>
            <p className="text-slate-600 leading-relaxed mb-1">Société par Actions Simplifiée (SAS) au capital de 315 074,50 €</p>
            <p className="text-slate-600 leading-relaxed mb-1">Immatriculation SIREN 582 090 718 - APE 2361Z</p>
            <p className="text-slate-600 leading-relaxed mb-1">Siège social : 32 rue de Cambrai, 75019 Paris</p>
            <p className="text-slate-600 leading-relaxed mb-1">Téléphone : 01 55 34 79 20</p>
            <p className="text-slate-600 leading-relaxed mb-1">Email : contact@soprel-groupe.fr</p>
            <p className="text-slate-600 leading-relaxed mb-1">Directeur de la publication : Le Président de la société SOPREL GROUPE</p>
          </div>

          <h2 className="font-display font-bold text-2xl text-[#0e1c3f] uppercase mt-10 mb-4">2. Hébergement</h2>
          <div className="bg-slate-50 border border-slate-200 p-6 mb-8">
            <p className="text-slate-700 leading-relaxed mb-1"><strong>OVHcloud</strong></p>
            <p className="text-slate-600 leading-relaxed mb-1">SAS au capital de 10 174 560 €</p>
            <p className="text-slate-600 leading-relaxed mb-1">RCS Lille Métropole 424 761 419 00045</p>
            <p className="text-slate-600 leading-relaxed mb-1">Siège social : 2 rue Kellermann, 59100 Roubaix, France</p>
            <p className="text-slate-600 leading-relaxed mb-1">Téléphone : 1007 (depuis la France)</p>
            <p className="text-slate-600 leading-relaxed">Site web : <a href="https://www.ovhcloud.com" target="_blank" rel="noopener noreferrer" className="text-[#0078b7] hover:underline">www.ovhcloud.com</a></p>
          </div>

          <h2 className="font-display font-bold text-2xl text-[#0e1c3f] uppercase mt-10 mb-4">3. Conception du site</h2>
          <p className="text-slate-600 leading-relaxed mb-6">
            Le site a été conçu et développé par <a href="https://www.webisula.com/" target="_blank" rel="noopener noreferrer" className="text-[#0078b7] hover:underline">WEBISULA</a>.
          </p>

          <h2 className="font-display font-bold text-2xl text-[#0e1c3f] uppercase mt-10 mb-4">4. Propriété intellectuelle</h2>
          <p className="text-slate-600 leading-relaxed mb-6">
            L'ensemble du contenu de ce site (textes, images, photographies, logos, vidéos, marques, éléments graphiques et sonores) est la propriété exclusive de SOPREL GROUPE ou de ses partenaires et est protégé par les lois françaises et internationales relatives à la propriété intellectuelle.
          </p>
          <p className="text-slate-600 leading-relaxed mb-6">
            Toute reproduction, représentation, modification, publication, adaptation de tout ou partie des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite, sauf autorisation écrite préalable de SOPREL GROUPE.
          </p>
          <p className="text-slate-600 leading-relaxed mb-6">
            Toute exploitation non autorisée du site ou de son contenu serait constitutive d'une contrefaçon sanctionnée par les articles L.335-2 et suivants du Code de la Propriété Intellectuelle.
          </p>

          <h2 className="font-display font-bold text-2xl text-[#0e1c3f] uppercase mt-10 mb-4">5. Limitation de responsabilité</h2>
          <p className="text-slate-600 leading-relaxed mb-6">
            SOPREL GROUPE s'efforce d'assurer au mieux l'exactitude et la mise à jour des informations diffusées sur ce site. Toutefois, SOPREL GROUPE ne peut garantir l'exactitude, la précision ou l'exhaustivité des informations mises à disposition sur ce site.
          </p>
          <p className="text-slate-600 leading-relaxed mb-6">
            En conséquence, SOPREL GROUPE décline toute responsabilité pour toute imprécision, inexactitude ou omission portant sur des informations disponibles sur ce site, ainsi que pour tous dommages résultant d'une intrusion frauduleuse d'un tiers ayant entraîné une modification des informations mises à disposition sur le site.
          </p>

          <h2 className="font-display font-bold text-2xl text-[#0e1c3f] uppercase mt-10 mb-4">6. Liens hypertextes</h2>
          <p className="text-slate-600 leading-relaxed mb-6">
            Le site peut contenir des liens hypertextes vers d'autres sites internet. SOPREL GROUPE n'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu ou aux éventuels collectes et transmissions de données personnelles effectuées par ces sites.
          </p>

          <h2 className="font-display font-bold text-2xl text-[#0e1c3f] uppercase mt-10 mb-4">7. Cookies</h2>
          <p className="text-slate-600 leading-relaxed mb-6">
            Le site utilise des cookies nécessaires à son bon fonctionnement. Pour plus d'informations sur l'utilisation des cookies, veuillez consulter notre <a href="/politique-confidentialite" className="text-[#0078b7] hover:underline">Politique de confidentialité</a>.
          </p>

          <h2 className="font-display font-bold text-2xl text-[#0e1c3f] uppercase mt-10 mb-4">8. Droit applicable et juridiction compétente</h2>
          <p className="text-slate-600 leading-relaxed mb-6">
            Les présentes mentions légales sont régies par le droit français. En cas de litige, et après tentative de recherche d'une solution amiable, compétence expresse est attribuée aux tribunaux compétents de Paris.
          </p>

          <div className="border-t border-slate-200 pt-6 mt-10">
            <p className="text-slate-400 text-sm">
              Dernière mise à jour : Avril 2026
            </p>
          </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MentionsLegalesPage;
